import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/SimpleAuthContext';

function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Log the full URL for debugging
        console.log('Full URL:', window.location.href);
        console.log('Hash:', window.location.hash);
        console.log('Search:', window.location.search);

        // HandCash may return data in hash fragment or query params
        let authToken = null;
        let userHandle = null;

        // Check query params first (HandCash typically uses this)
        const searchParams = new URLSearchParams(window.location.search);
        authToken = searchParams.get('authToken') || searchParams.get('token') || searchParams.get('code');
        userHandle = searchParams.get('handle') || searchParams.get('alias') || searchParams.get('username');

        // Check hash fragment if not found in query
        if (!authToken && window.location.hash) {
          const hashParams = new URLSearchParams(window.location.hash.substring(1));
          authToken = hashParams.get('authToken') || hashParams.get('token') || hashParams.get('code');
          if (!userHandle) {
            userHandle = hashParams.get('handle') || hashParams.get('alias') || hashParams.get('username');
          }
        }

        // Log all URL parameters for debugging
        console.log('All search params:', Array.from(searchParams.entries()));
        if (window.location.hash) {
          const hashParams = new URLSearchParams(window.location.hash.substring(1));
          console.log('All hash params:', Array.from(hashParams.entries()));
        }
        console.log('Auth token found:', authToken);
        console.log('User handle found:', userHandle);

        if (authToken) {
          // Use the handle from URL if available, otherwise generate a demo handle
          // In production, you would make an API call to HandCash using the token
          // to get the user's actual profile information
          
          // If no handle provided, create a demo handle from token
          const finalHandle = userHandle || `@demo_${authToken.slice(0, 8)}`;
          const displayName = userHandle || `Demo User ${authToken.slice(0, 6)}`;
          
          const userData = {
            authToken,
            handle: finalHandle, // This would be the actual handle from HandCash API
            displayName: displayName // This would be from HandCash profile
          };
          
          console.log('Setting user data:', userData);
          
          localStorage.setItem('user', JSON.stringify(userData));
          setUser(userData);
          
          // Redirect to dashboard
          console.log('Authentication successful, redirecting to dashboard');
          navigate('/dashboard');
        } else {
          console.error('No auth token found in URL');
          setError('Authentication failed - no token received');
          
          // Show error message before redirecting
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        }
      } catch (error) {
        console.error('Auth callback failed:', error);
        setError('Authentication failed - ' + error.message);
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    };

    handleCallback();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-500 text-xl mb-4">⚠️</div>
            <p className="text-white mb-2">Authentication Failed</p>
            <p className="text-gray-400 text-sm">{error}</p>
            <p className="text-gray-500 text-xs mt-4">Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500 mx-auto mb-4"></div>
            <p className="text-white mb-2">Completing authentication...</p>
            <p className="text-gray-400 text-sm">Setting up your profile</p>
          </>
        )}
      </div>
    </div>
  );
}

export default AuthCallback;